import { instrumentation } from '@partnerslate/core'

export const viewProjectDetail = (projectId: string) => {
  instrumentation.mixpanelTrack('View Project Details', { 'Project ID': projectId })
}

export const viewProjectDetailModal = (projectId: string) => {
  instrumentation.mixpanelTrack('View Project Details Modal', { 'Project ID': projectId })
}

export const openedInAppNotifications = () => {
  instrumentation.mixpanelTrack('In App Notifications Opened')
}

export const clickedInAppNotification = (knockItemId: string) => {
  instrumentation.mixpanelTrack('In App Notification Clicked', { 'Knock Item ID': knockItemId })
}

export const clickedInAppNotificationMarkAllAsRead = () => {
  instrumentation.mixpanelTrack('In App Notification Mark All As Read Clicked')
}
